// extracted by mini-css-extract-plugin
export default {"form_container":"style_form_container__e1AfY","formGroup":"style_formGroup__pTJbW","title":"style_title__BQ6Fy","button":"style_button__4ZyhI"};